import 'dayjs/locale/fa';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import jalaali from 'jalaali-js';
import jalaliday from 'jalaliday';

dayjs.locale('fa');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(jalaliday);

// Save the original calendar method
const originalCalendar = dayjs.prototype.calendar;

/**
 * Creates a proxy around a Dayjs instance to override methods when using the Jalali calendar.
 */

function createJalaliProxy(original: dayjs.Dayjs): dayjs.Dayjs {
  const handler: ProxyHandler<dayjs.Dayjs> = {
    get(target, prop, _receiver) {
      // Override format for 'YYYY/MM/DD'
      if (prop === 'format') {
        return function f(fmt: string) {
          if (fmt === 'YYYY/MM/DD') {
            const gDate = target.toDate();
            const { jy, jm, jd } = jalaali.toJalaali(gDate.getFullYear(), gDate.getMonth() + 1, gDate.getDate());
            return `${jy}/${jm < 10 ? `0${jm}` : jm}/${jd < 10 ? `0${jd}` : jd}`;
          }
          return target.format(fmt);
        };
      }
      // Override year to return the Jalali year
      if (prop === 'year') {
        return function y() {
          const gDate = target.toDate();
          const { jy } = jalaali.toJalaali(gDate.getFullYear(), gDate.getMonth() + 1, gDate.getDate());
          return jy;
        };
      }
      // For all other properties, delegate to the original Dayjs instance
      const value = target[prop as keyof dayjs.Dayjs];
      return typeof value === 'function' ? value.bind(target) : value;
    },
  };
  return new Proxy(original, handler);
}

// Override calendar so that when using 'jalali' we return a proxied Dayjs instance.
dayjs.prototype.calendar = function calendar(this: dayjs.Dayjs, calendarSystem: string, ...args: any[]): dayjs.Dayjs {
  if (calendarSystem === 'jalali') {
    const originalInstance = originalCalendar.call(this, calendarSystem, ...args);
    return createJalaliProxy(originalInstance);
  }
  return originalCalendar.call(this, calendarSystem, ...args);
};

export default dayjs;
